import { useState, useEffect } from "react";
import { getProgressSummary } from "../api/lfApiProgress";
import { useError } from "../contexts/ErrorContext";
import StudyPlanCards from "../cards/progress/StudyPlanCards";
import WeeklyStats from "../cards/progress/WeeklyStats";
import Accomplishments from "../cards/progress/Accomplishments";

function ProgressPage() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { setError: setGlobalError } = useError();

  useEffect(() => {
    let cancelled = false;

    async function fetchProgress() {
      setIsLoading(true);
      setError(null);

      const result = await getProgressSummary(30, setGlobalError);

      if (cancelled) return;

      if (result) {
        setData(result);
      } else {
        setError("Unable to load your progress. Please try again later.");
      }
      setIsLoading(false);
    }

    fetchProgress();

    return () => {
      cancelled = true;
    };
  }, [setGlobalError]);

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin" />
        <p className="mt-4 text-gray-500 text-sm">Loading your progress...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <p className="text-gray-500 text-sm">{error}</p>
        <button
          type="button"
          className="mt-4 px-4 py-2 bg-blue-500 text-white text-sm rounded-xl hover:bg-blue-600 transition-colors"
          onClick={() => window.location.reload()}
        >
          Try again
        </button>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6 pt-6 pb-8">
      {/* Two-column grid on desktop, single column on mobile */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left column: study plans (2/3 width on desktop) */}
        <div className="md:col-span-2 flex flex-col gap-6">
          <StudyPlanCards studyPlans={data.study_plans} />
        </div>

        {/* Right column: weekly stats, accomplishments (1/3 width on desktop) */}
        <div className="flex flex-col gap-6">
          <WeeklyStats overview={data.overview} streakDays={data.overview?.learning_streak_days} />
          <Accomplishments accomplishments={data.accomplishments} />
        </div>
      </div>
    </div>
  );
}

export default ProgressPage;
